// extracted by mini-css-extract-plugin
export default {"wrapper":"MobilePage_wrapper__UjXdt","card":"MobilePage_card__5xIsO"};